import type { TFunction } from 'i18next'

/**
 * Form doğrulama mesajı çözümü (020). Şemalar/sunucu-hata eşlemesi mesaj olarak i18n anahtarı taşır
 * (ör. `validation.required`, `admin.grants.errors.duplicateCode`); gösterimde aktif dile çevrilir.
 * i18next bir anahtarı bulamazsa girdiyi olduğu gibi döndürür → zod'un çevirisiz varsayılan mesajları
 * da güvenle geçer.
 */
export function resolveFieldError(
  message: string | undefined,
  t: TFunction,
): string | undefined {
  if (!message) return undefined
  return t(message)
}
